import React from "react";
import { Avatar } from "@fluentui/react-components";
import { Mail, Phone } from "lucide-react";
import HoverCard from "../hoverCard/HoverCard";
import { formatPhoneForTelHref, formatPhoneNumberForDisplay } from "../../helpers/utils";
import styles from "./EntityDetails.module.scss";

// Read-only mini card for a single Contact reference (Sponsor / Executive / a Stakeholder)
const DetailContactCard = ({ contact }) => {
  if (!contact) return null;

  return (
    <div className={styles.miniContactCard}>
      <HoverCard
        HoverCardTrigger={
          <Avatar color="colorful" size={32} name={contact.name || contact.email || contact.phone} />
        }
        AvatarId={contact.id}
        AvatarName={contact.name}
        AvatarEmail={contact.email}
        AvatarPhone={contact.phone}
        AvatarIsExternal={true}
        CanSendMessage={false}
      />
      <div className={styles.miniContactBody}>
        <p className={styles.miniContactName}>{contact.name || contact.email || contact.phone}</p>
        {(contact.email || contact.phone) && (
          <div className={styles.miniContactMeta}>
            {contact.email && (
              <a href={`mailto:${contact.email}`} className={styles.miniContactLink} title={contact.email}>
                <Mail size={12} color="#342C82" />
              </a>
            )}
            {contact.phone && (
              <a
                href={formatPhoneForTelHref(contact.phone)}
                className={styles.miniContactLink}
                title={formatPhoneNumberForDisplay(contact.phone)}
              >
                <Phone size={12} color="#342C82"/>
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailContactCard;
